var $ = require('jquery');
var slick = require('slick-carousel');

module.exports = {
	init: function () {
		var slider = $('.block.slider .items');
		if (slider.length > 0) {
			for (var i = 0; i < slider.length; i++) {
				// Init first slider
				$(slider[i]).slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: true,
					autoplay: false,
					infinite: true,
					fade: true,
					appendDots: $(slider[i]).parent().siblings('.slick-controls'),
					appendArrows: $(slider[i]).parent().siblings('.slick-controls'),
					prevArrow:
						'<button type="button" class="slick-prev">Previous <svg width="36" height="16" viewBox="0 0 36 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.384689 8.78206C-0.00583267 8.39153 -0.00583267 7.75837 0.384689 7.36784L6.74865 1.00388C7.13918 0.613359 7.77234 0.613359 8.16286 1.00388C8.55339 1.39441 8.55339 2.02757 8.16286 2.4181L2.50601 8.07495L8.16286 13.7318C8.55339 14.1223 8.55339 14.7555 8.16286 15.146C7.77234 15.5365 7.13918 15.5365 6.74865 15.146L0.384689 8.78206ZM35.7734 9.07495H1.0918V7.07495H35.7734V9.07495Z" fill="white"/></svg></button>',
					nextArrow:
						'<button type="button" class="slick-next">Next <svg width="36" height="16" viewBox="0 0 36 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.6149 8.78206C36.0055 8.39153 36.0055 7.75837 35.6149 7.36784L29.251 1.00388C28.8605 0.613359 28.2273 0.613359 27.8368 1.00388C27.4462 1.39441 27.4462 2.02757 27.8368 2.4181L33.4936 8.07495L27.8368 13.7318C27.4462 14.1223 27.4462 14.7555 27.8368 15.146C28.2273 15.5365 28.8605 15.5365 29.251 15.146L35.6149 8.78206ZM0.226206 9.07495H34.9078V7.07495H0.226206V9.07495Z" fill="white"/></svg></button>'
				});
			}
		}
		var sliderTwo = $('.block.slider.style-2 .items');
		if (sliderTwo.length > 0) {
			for (var i = 0; i < sliderTwo.length; i++) {
				// Init first sliderTwo
				// $(sliderTwo[i]).on('beforeChange', function(slick, currentSlide, nextSlide){
				//     console.log('slick obj', slick);
				//     console.log('current slide', currentSlide);
				//     console.log('next slide', nextSlide);
				//     $(sliderTwo[i] + ' .slick-slide').eq(nextSlide).addClass('hippy');
				// });
				$(sliderTwo[i]).slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: true,
					autoplay: false,
					infinite: false,
					centerMode: true,
					centerPadding: '100px',
					cssEase: 'linear',
					speed: 300,
					appendDots: $(sliderTwo[i]).siblings('.slick-controls-wrapper').find('.slick-controls'),
					appendArrows: $(sliderTwo[i]).siblings('.slick-controls-wrapper').find('.slick-controls'),
					prevArrow:
						'<button type="button" class="slick-prev">Previous <svg width="36" height="16" viewBox="0 0 36 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.384689 8.78206C-0.00583267 8.39153 -0.00583267 7.75837 0.384689 7.36784L6.74865 1.00388C7.13918 0.613359 7.77234 0.613359 8.16286 1.00388C8.55339 1.39441 8.55339 2.02757 8.16286 2.4181L2.50601 8.07495L8.16286 13.7318C8.55339 14.1223 8.55339 14.7555 8.16286 15.146C7.77234 15.5365 7.13918 15.5365 6.74865 15.146L0.384689 8.78206ZM35.7734 9.07495H1.0918V7.07495H35.7734V9.07495Z" fill="white"/></svg></button>',
					nextArrow:
						'<button type="button" class="slick-next">Next <svg width="36" height="16" viewBox="0 0 36 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.6149 8.78206C36.0055 8.39153 36.0055 7.75837 35.6149 7.36784L29.251 1.00388C28.8605 0.613359 28.2273 0.613359 27.8368 1.00388C27.4462 1.39441 27.4462 2.02757 27.8368 2.4181L33.4936 8.07495L27.8368 13.7318C27.4462 14.1223 27.4462 14.7555 27.8368 15.146C28.2273 15.5365 28.8605 15.5365 29.251 15.146L35.6149 8.78206ZM0.226206 9.07495H34.9078V7.07495H0.226206V9.07495Z" fill="white"/></svg></button>',
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								centerPadding: '50px'
							}
						}
					]
				});
			}
		}

		var sliderThree = $('.block.poster.style-1 .items');
		if (sliderThree.length > 0) {
			for (var i = 0; i < sliderThree.length; i++) {
				// Init first sliderTwo
				// $(sliderTwo[i]).on('beforeChange', function(slick, currentSlide, nextSlide){
				//     console.log('slick obj', slick);
				//     console.log('current slide', currentSlide);
				//     console.log('next slide', nextSlide);
				//     $(sliderTwo[i] + ' .slick-slide').eq(nextSlide).addClass('hippy');
				// });
				$(sliderThree[i]).slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
					autoplay: true,
					infinite: true,
					cssEase: 'linear',
					speed: 600,
					autoplaySpeed: 4000,
					// appendDots: $(sliderTwo[i]).siblings('.slick-controls-wrapper').find('.slick-controls'),
					// appendArrows: $(sliderTwo[i]).siblings('.slick-controls-wrapper').find('.slick-controls'),
					prevArrow:
						'<button type="button" class="slick-prev">Previous <svg width="36" height="16" viewBox="0 0 36 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.384689 8.78206C-0.00583267 8.39153 -0.00583267 7.75837 0.384689 7.36784L6.74865 1.00388C7.13918 0.613359 7.77234 0.613359 8.16286 1.00388C8.55339 1.39441 8.55339 2.02757 8.16286 2.4181L2.50601 8.07495L8.16286 13.7318C8.55339 14.1223 8.55339 14.7555 8.16286 15.146C7.77234 15.5365 7.13918 15.5365 6.74865 15.146L0.384689 8.78206ZM35.7734 9.07495H1.0918V7.07495H35.7734V9.07495Z" fill="white"/></svg></button>',
					nextArrow:
						'<button type="button" class="slick-next">Next <svg width="36" height="16" viewBox="0 0 36 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.6149 8.78206C36.0055 8.39153 36.0055 7.75837 35.6149 7.36784L29.251 1.00388C28.8605 0.613359 28.2273 0.613359 27.8368 1.00388C27.4462 1.39441 27.4462 2.02757 27.8368 2.4181L33.4936 8.07495L27.8368 13.7318C27.4462 14.1223 27.4462 14.7555 27.8368 15.146C28.2273 15.5365 28.8605 15.5365 29.251 15.146L35.6149 8.78206ZM0.226206 9.07495H34.9078V7.07495H0.226206V9.07495Z" fill="white"/></svg></button>',
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								centerPadding: '50px'
							}
						}
					]
				});
			}
		}		
	}
};
